import { render, staticRenderFns } from "./AccountPage.html?vue&type=template&id=bea8adcc&scoped=true&"
import script from "./AccountPage.js?vue&type=script&lang=js&"
export * from "./AccountPage.js?vue&type=script&lang=js&"
import style0 from "./AccountPage.scss?vue&type=style&index=0&id=bea8adcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea8adcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
